import {
  bindable,
  bindingMode,
  customElement,
  ComponentAttached,
} from "aurelia-framework";

@customElement("k-collapsible")
export class KCollabsible implements ComponentAttached {
  @bindable({ defaultBindingMode: bindingMode.twoWay }) collapsed: boolean =
    true;
  @bindable textCollapsed: string = "show";
  @bindable textExpanded: string = "hide";
  anchorText: HTMLSpanElement;
  collapsibleDiv: HTMLElement;

  private mode: Mode = Mode.idle;
  private origHeight?: number;

  attached() {
    // set initial state
    this.animationFinished(this.collapsed ? Mode.collapsing : Mode.expanding);
    // add event listener for animation end
    $(this.collapsibleDiv).on(
      "transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd",
      (e) => {
        this.animationFinished(this.mode);
        this.mode = Mode.idle;
      },
    );
  }

  collapsedChanged(newValue: boolean, oldValue?: boolean) {
    if (this.anchorText && this.collapsibleDiv) {
      if (!newValue) {
        this.mode = Mode.expanding;
        this.collapsibleDiv.style.height = "0px";
        this.collapsibleDiv.classList.remove("collapse");
        this.collapsibleDiv.classList.add("collapsing");
        setTimeout(() => {
          this.collapsibleDiv.style.height =
            (this.origHeight || this.collapsibleDiv.scrollHeight) + "px";
        }, 100);
      } else {
        this.mode = Mode.collapsing;
        this.origHeight = this.collapsibleDiv.scrollHeight;
        this.collapsibleDiv.style.height = this.origHeight + "px";
        this.collapsibleDiv.classList.add("collapsing");
        this.collapsibleDiv.classList.remove("show");
        this.collapsibleDiv.classList.remove("collapse");
        setTimeout(() => (this.collapsibleDiv.style.height = "0px"), 100);
      }
    }
  }

  toggle() {
    this.collapsed = !this.collapsed;
  }

  private animationFinished(mode: Mode) {
    this.anchorText.innerHTML = this.getText();
    this.collapsibleDiv.classList.remove("collapsing");
    this.collapsibleDiv.classList.add("collapse");
    if (mode == Mode.expanding) {
      this.collapsibleDiv.classList.add("show");
    }
    this.collapsibleDiv.style.removeProperty("height");
  }

  private getText() {
    if (this.collapsed)
      return "<i class='fa fa-chevron-down'></i> " + this.textCollapsed;
    else return "<i class='fa fa-chevron-up'></i>" + this.textExpanded;
  }
}

enum Mode {
  idle,
  collapsing,
  expanding,
}
